import React, {
    useEffect,/* , useState */
    useState
} from 'react';
import { FormControl, Grid, InputLabel, Select, } from '@material-ui/core';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
//import { Autocomplete } from '@mui/material';
import { LABEL_INPUT_FONT_SIZE, } from '../../ConstsAndUtils/utils';
import { toast } from 'react-toastify';

const horas = [
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30',
]

const turnos = [
    1,
    2,
    3,
    4,
    5
]

const HorarioPrestador = (props) => {

    const { validateHorario, editing, dataCrear } = props

    const [entradaLunesJueves, setEntradaLunesJueves] = useState(editing ? dataCrear?.["e_lunes_jueves"] : '07:00')
    const [salidaLunesJueves, setSalidaLunesJueves] = useState(editing ? dataCrear?.["s_lunes_jueves"] : '22:00')
    const [turnosLunes, setTurnosLunes] = useState(editing ? dataCrear?.["t_lunes_jueves"] : 1)
    const [entradaViernes, setEntradaViernes] = useState(editing ? dataCrear?.["e_viernes"] : '0a')
    const [salidaViernes, setSalidaViernes] = useState(editing ? dataCrear?.["s_viernes"] : '0a')
    const [turnosViernes, setTurnosViernes] = useState(editing ? dataCrear?.["t_viernes"] : '0a')
    const [entradaSabado, setEntradaSabado] = useState(editing ? dataCrear?.["e_sabados"] : '0a')
    const [salidaSabado, setSalidaSabado] = useState(editing ? dataCrear?.["s_sabados"] : '0a')
    const [turnosSabados, setTurnosSabados] = useState(editing ? dataCrear?.["t_sabados"] : '0a')
    const [entradaDomingo, setEntradaDomingo] = useState(editing ? dataCrear?.["e_domingos"] : '0a')
    const [salidaDomingo, setSalidaDomingo] = useState(editing ? dataCrear?.["s_domingos"] : '0a')
    const [turnosDomingos, setTurnosDomingos] = useState(editing ? dataCrear?.["t_domingos"] : '0a')
    const [entradaFestivos, setEntradaFestivos] = useState(editing ? dataCrear?.["e_festivos"] : '0a')
    const [salidaFestivos, setSalidaFestivos] = useState(editing ? dataCrear?.["s_festivos"] : '0a')
    const [turnosFestivos, setTurnosFestivos] = useState(editing ? dataCrear?.["t_festivos"] : '0a')

    useEffect(() => {
        let extra = {
            e_lunes_jueves: entradaLunesJueves,
            s_lunes_jueves: salidaLunesJueves,
            t_lunes_jueves:turnosLunes,
            e_viernes: entradaViernes,
            s_viernes: salidaViernes,
            t_viernes:turnosViernes,
            e_sabados: entradaSabado,
            s_sabados: salidaSabado,
            t_sabados:turnosSabados,
            e_domingos: entradaDomingo,
            s_domingos: salidaDomingo,
            t_domingos: turnosDomingos,
            e_festivos: entradaFestivos,
            s_festivos: salidaFestivos,
            t_festivos: turnosFestivos,
        }

        validateHorario(extra)

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entradaLunesJueves,
        salidaLunesJueves,
        entradaViernes,
        salidaViernes,
        entradaSabado,
        salidaSabado,
        entradaDomingo,
        salidaDomingo,
        entradaFestivos,
        salidaFestivos,
        turnosLunes,
        turnosViernes,
        turnosSabados,
        turnosDomingos,
        turnosFestivos,
    ])

    const setCerradoEntrada = (cerrar) => {
        cerrar('0a')
    }

    const setCerradoSalida = (cerrar) => {
        cerrar('0a')
    }

    const cierreDespuesDeApertura = (apertura, cierre) => {
        if (apertura >= cierre) {
            toast.error('El cierre debe ser después de la apertura')
            return false
        } else {
            return true
        }
    }

    const aperturaAntesDeCierre = (apertura, cierre) => {
        if (cierre === '0a') {
            return true
        } else {
            if (apertura >= cierre) {
                toast.error('La apertura debe ser antes del cierre')
                return false
            } else {
                return true
            }
        }

    }

    return (
        <Grid
            container
            item
            xs={12}
            spacing={4}
            style={{
                backgroundColor: 'white',
                paddingTop: 5,
                borderRadius: 5,
                paddingBottom: 5,
                marginTop: 15,
                marginLeft:15,
                paddingRight:35
            }}>
            <Grid item xs={12}>
                <h4>Horario de atención</h4>
            </Grid>

            <Grid item xs={3}>
                <AppTextInput
                    //inputProps={{style: { fontSize: 14 }}}
                    disabled
                    size={"small"}
                    InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
                    fullWidth
                    variant="outlined"
                    value={'Lunes a Jueves'}
                />
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Apertura"}
                    </InputLabel>
                    <Select
                        label="Apertura"
                        value={entradaLunesJueves}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {
                            if (aperturaAntesDeCierre(e.target.value, salidaLunesJueves)) {
                                setEntradaLunesJueves(e.target.value)
                            }
                        }}
                    >
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cierre"}
                    </InputLabel>
                    <Select
                        label="Cierre"
                        value={salidaLunesJueves}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (cierreDespuesDeApertura(entradaLunesJueves, e.target.value)) {
                                setSalidaLunesJueves(e.target.value)
                            }

                        }}
                    >
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cantidad de turnos"}
                    </InputLabel>
                    <Select
                        label="Cantidad de turnos"
                        value={turnosLunes}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {
                            setTurnosLunes(e.target.value)
                        }}
                    >
          
                        {
                            turnos.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>



            <Grid item xs={3}>
                <AppTextInput
                    //inputProps={{style: { fontSize: 14 }}}
                    disabled
                    size={"small"}
                    InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
                    fullWidth
                    variant="outlined"
                    value={'Viernes'}
                />
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Apertura"}
                    </InputLabel>
                    <Select
                        label="Apertura"
                        value={entradaViernes}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (e.target.value === '0a') {
                                setCerradoSalida(setSalidaViernes)
                                setCerradoSalida(setTurnosViernes)
                                setEntradaViernes(e.target.value)
                            } else {
                                if (aperturaAntesDeCierre(e.target.value, salidaViernes)) {
                                    setEntradaViernes(e.target.value)
                                }
                            }

                        }}
                    >

                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cierre"}
                    </InputLabel>
                    <Select
                        label="Cierre"
                        value={salidaViernes}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (entradaViernes !== '0a') {
                                if (e.target.value === '0a') {
                                    setCerradoEntrada(setEntradaViernes)
                                    setCerradoEntrada(setTurnosViernes)
                                    setSalidaViernes(e.target.value)
                                } else {
                                    if (cierreDespuesDeApertura(entradaViernes, e.target.value)) {
                                        setSalidaViernes(e.target.value)
                                    }
                                }
                            } else {
                                toast.warn('Debe seleccionar hora de apertura para otorgar una hora de cierre')
                            }

                        }}
                    >
                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cantidad de turnos"}
                    </InputLabel>
                    <Select
                        label="Cantidad de turnos"
                        value={turnosViernes}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {
                            setTurnosViernes(e.target.value)
                        }}
                    >
                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            turnos.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <AppTextInput
                    //inputProps={{style: { fontSize: 14 }}}
                    disabled
                    size={"small"}
                    InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
                    fullWidth
                    variant="outlined"
                    value={'Sábado'}
                />
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Apertura"}
                    </InputLabel>
                    <Select
                        label="Apertura"
                        value={entradaSabado}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (e.target.value === '0a') {
                                setCerradoSalida(setSalidaSabado)
                                setCerradoSalida(setTurnosSabados)
                                setEntradaSabado(e.target.value)
                            } else {
                                if (aperturaAntesDeCierre(e.target.value, salidaSabado)) {
                                    setEntradaSabado(e.target.value)
                                }
                            }

                        }}
                    >

                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cierre"}
                    </InputLabel>
                    <Select
                        label="Cierre"
                        value={salidaSabado}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (entradaSabado !== '0a') {
                                if (e.target.value === '0a') {
                                    setCerradoEntrada(setEntradaSabado)
                                    setCerradoEntrada(setTurnosSabados)
                                    setSalidaSabado(e.target.value)
                                } else {
                                    if (cierreDespuesDeApertura(entradaSabado, e.target.value)) {
                                        setSalidaSabado(e.target.value)
                                    }
                                }
                            } else {
                                toast.warn('Debe seleccionar hora de apertura para otorgar una hora de cierre')
                            }
                        }}
                    >
                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cantidad de turnos"}
                    </InputLabel>
                    <Select
                        label="Cantidad de turnos"
                        value={turnosSabados}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {
                            setTurnosSabados(e.target.value)
                        }}
                    >
                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            turnos.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <AppTextInput
                    //inputProps={{style: { fontSize: 14 }}}
                    disabled
                    size={"small"}
                    InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
                    fullWidth
                    variant="outlined"
                    value={'Domingo'}
                />
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Apertura"}
                    </InputLabel>
                    <Select
                        label="Apertura"
                        value={entradaDomingo}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (e.target.value === '0a') {
                                setCerradoSalida(setSalidaDomingo)
                                setCerradoSalida(setTurnosDomingos)
                                setEntradaDomingo(e.target.value)
                            } else {
                                if (aperturaAntesDeCierre(e.target.value, salidaDomingo)) {
                                    setEntradaDomingo(e.target.value)
                                }
                            }

                        }}
                    >

                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cierre"}
                    </InputLabel>
                    <Select
                        label="Cierre"
                        value={salidaDomingo}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (entradaDomingo !== '0a') {
                                if (e.target.value === '0a') {
                                    setCerradoEntrada(setEntradaDomingo)
                                    setCerradoEntrada(setTurnosDomingos)
                                    setSalidaDomingo(e.target.value)
                                } else {
                                    if (cierreDespuesDeApertura(entradaDomingo, e.target.value)) {
                                        setSalidaDomingo(e.target.value)
                                    }
                                }
                            } else {
                                toast.warn('Debe seleccionar hora de apertura para otorgar una hora de cierre')
                            }
                        }}
                    >
                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cantidad de turnos"}
                    </InputLabel>
                    <Select
                        label="Cantidad de turnos"
                        value={turnosDomingos}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {
                            setTurnosDomingos(e.target.value)
                        }}
                    >
                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            turnos.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <AppTextInput
                    //inputProps={{style: { fontSize: 14 }}}
                    disabled
                    size={"small"}
                    InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
                    fullWidth
                    variant="outlined"
                    value={'Festivos'}
                />
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Apertura"}
                    </InputLabel>
                    <Select
                        label="Apertura"
                        value={entradaFestivos}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (e.target.value === '0a') {
                                setCerradoSalida(setSalidaFestivos)
                                setCerradoSalida(setTurnosFestivos)
                                setEntradaFestivos(e.target.value)
                            } else {
                                if (aperturaAntesDeCierre(e.target.value, salidaFestivos)) {
                                    setEntradaFestivos(e.target.value)
                                }
                            }

                        }}
                    >

                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cierre"}
                    </InputLabel>
                    <Select
                        label="Cierre"
                        value={salidaFestivos}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {

                            if (entradaFestivos !== '0a') {
                                if (e.target.value === '0a') {
                                    setCerradoEntrada(setEntradaFestivos)
                                    setCerradoEntrada(setTurnosFestivos)
                                    setSalidaFestivos(e.target.value)
                                } else {
                                    if (cierreDespuesDeApertura(entradaFestivos, e.target.value)) {
                                        setSalidaFestivos(e.target.value)
                                    }
                                }
                            } else {
                                toast.warn('Debe seleccionar hora de apertura para otorgar una hora de cierre')
                            }
                        }}
                    >
                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            horas.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={3}>
                <FormControl size="small" fullWidth>
                    <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                        {"Cantidad de turnos"}
                    </InputLabel>
                    <Select
                        label="Cantidad de turnos"
                        value={turnosFestivos}
                        native
                        id="grouped-native-select"
                        fullWidth
                        variant='outlined'
                        onChange={(e) => {
                            setTurnosFestivos(e.target.value)
                        }}
                    >
                        <option key={'0a'} value={'0a'}>
                            Cerrado
                        </option>
                        {
                            turnos.map((item, index) => {
                                return <option key={index} value={item}>
                                    {item}
                                </option>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>

        </Grid>
    );
};

export default HorarioPrestador;
